/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ViewCardIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'View Card',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 33a1 1 0 0 0 1 1h7V18H2ZM3 2a1 1 0 0 0-1 1v11h8V2ZM26 34h7a1 1 0 0 0 1-1v-5h-8ZM33 2h-7v6h8V3a1 1 0 0 0-1-1ZM14 22h8v12h-8zM14 2h8v16h-8zM26 12h8v12h-8z"
    />
  </svg>`;
};
